import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

interface DistributionBucket {
  range_start: number;
  range_end: number;
  count: number;
}

interface ScoreDistributionChartProps {
  data: DistributionBucket[];
  title?: string;
  color?: string;
  height?: number;
}

export function ScoreDistributionChart({
  data,
  title,
  color = "#1752B7",
  height = 250,
}: ScoreDistributionChartProps) {
  if (!data || data.length === 0) {
    return (
      <div className="text-center py-8 text-slate-400 text-sm">
        Pas de données
      </div>
    );
  }

  const chartData = data.map((bucket) => ({
    range: `${(bucket.range_start * 100).toFixed(0)}-${(bucket.range_end * 100).toFixed(0)}%`,
    count: bucket.count,
  }));

  return (
    <div>
      {title && (
        <p className="text-sm font-semibold text-slate-700 mb-2">{title}</p>
      )}
      <ResponsiveContainer width="100%" height={height}>
        <BarChart
          data={chartData}
          margin={{ top: 5, right: 10, left: 0, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
          <XAxis
            dataKey="range"
            tick={{ fontSize: 11, fill: "#64748b" }}
            angle={-45}
            textAnchor="end"
            height={60}
          />
          <YAxis
            tick={{ fontSize: 11, fill: "#64748b" }}
            allowDecimals={false}
          />
          <Tooltip
            contentStyle={{
              borderRadius: "8px",
              border: "1px solid #e2e8f0",
              fontSize: "12px",
            }}
          />
          <Bar dataKey="count" fill={color} radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
